angular.module( 'acme.view.application.donations.config', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.donations.config.settings',
  'acme.view.application.donations.config.list',
  'acme.view.application.donations.config.controllers',
  'acme.common.directive.dataGrid',
  'acme.view.application.dataGrid.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var donationsConfig = {
        name: 'application.donations.config',
        url: '/config',
        views: {
          "subview-main": {
            controller: 'DonationsConfigController',
            templateUrl: 'views/application/views/donations/config/config.tpl.html'
          }
        },
        data: {
          pageTitle: '  ',
          permissions: ['DONATIONS_CONFIG_VIEW']
        }
      };

    $stateProvider
      .state(donationsConfig);
});
